import packageJson from '../../package.json';
import './VersionBadge.css';

function VersionBadge() {
  return <div className="vap-version">v{packageJson.version}</div>;
}

export default VersionBadge;
